import * as ambassadorWixIamRecoveryV1Recovery from './iam-recovery-v1-recovery-recovery.http.js';
import * as ambassadorWixIamRecoveryV1RecoveryTypes from './iam-recovery-v1-recovery-recovery.types.js';
import * as ambassadorWixIamRecoveryV1RecoveryUniversalTypes from './iam-recovery-v1-recovery-recovery.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function sendRecoveryEmail(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIamRecoveryV1RecoveryUniversalTypes.SendRecoveryEmailRequest,
  ambassadorWixIamRecoveryV1RecoveryTypes.SendRecoveryEmailRequest,
  ambassadorWixIamRecoveryV1RecoveryUniversalTypes.SendRecoveryEmailResponse,
  ambassadorWixIamRecoveryV1RecoveryTypes.SendRecoveryEmailResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIamRecoveryV1Recovery.sendRecoveryEmail(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/send-email',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function sendActivationEmail(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIamRecoveryV1RecoveryUniversalTypes.SendActivationEmailRequest,
  ambassadorWixIamRecoveryV1RecoveryTypes.SendActivationEmailRequest,
  ambassadorWixIamRecoveryV1RecoveryUniversalTypes.SendActivationEmailResponse,
  ambassadorWixIamRecoveryV1RecoveryTypes.SendActivationEmailResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIamRecoveryV1Recovery.sendActivationEmail(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/activation-email',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function recover(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIamRecoveryV1RecoveryUniversalTypes.RecoverRequest,
  ambassadorWixIamRecoveryV1RecoveryTypes.RecoverRequest,
  ambassadorWixIamRecoveryV1RecoveryUniversalTypes.StateMachineResponse,
  ambassadorWixIamRecoveryV1RecoveryTypes.StateMachineResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixIamRecoveryV1Recovery.recover(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/recover',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  RecoveryToken as RecoveryTokenOriginal,
  TenantType as TenantTypeOriginal,
  TenantTypeWithLiterals as TenantTypeWithLiteralsOriginal,
  SendRecoveryEmailRequest as SendRecoveryEmailRequestOriginal,
  Redirect as RedirectOriginal,
  SendRecoveryEmailResponse as SendRecoveryEmailResponseOriginal,
  SendActivationEmailRequest as SendActivationEmailRequestOriginal,
  EmailOptions as EmailOptionsOriginal,
  SendActivationEmailResponse as SendActivationEmailResponseOriginal,
  RecoverRequest as RecoverRequestOriginal,
  StateMachineResponse as StateMachineResponseOriginal,
  StateMachineResponseStateDataOneOf as StateMachineResponseStateDataOneOfOriginal,
  StateType as StateTypeOriginal,
  StateTypeWithLiterals as StateTypeWithLiteralsOriginal,
  Identity as IdentityOriginal,
  Connection as ConnectionOriginal,
  ConnectionTypeOneOf as ConnectionTypeOneOfOriginal,
  IdpConnection as IdpConnectionOriginal,
  AuthenticatorConnection as AuthenticatorConnectionOriginal,
  IdentityProfile as IdentityProfileOriginal,
  PrivacyStatus as PrivacyStatusOriginal,
  PrivacyStatusWithLiterals as PrivacyStatusWithLiteralsOriginal,
  CustomField as CustomFieldOriginal,
  V1CustomValue as V1CustomValueOriginal,
  V1CustomValueValueOneOf as V1CustomValueValueOneOfOriginal,
  V1ListValue as V1ListValueOriginal,
  V1MapValue as V1MapValueOriginal,
  SecondaryEmail as SecondaryEmailOriginal,
  EmailTag as EmailTagOriginal,
  EmailTagWithLiterals as EmailTagWithLiteralsOriginal,
  Phone as PhoneOriginal,
  PhoneTag as PhoneTagOriginal,
  PhoneTagWithLiterals as PhoneTagWithLiteralsOriginal,
  AddressWrapper as AddressWrapperOriginal,
  Address as AddressOriginal,
  AddressTag as AddressTagOriginal,
  AddressTagWithLiterals as AddressTagWithLiteralsOriginal,
  Metadata as MetadataOriginal,
  Email as EmailOriginal,
  StatusV2 as StatusV2Original,
  StatusName as StatusNameOriginal,
  StatusNameWithLiterals as StatusNameWithLiteralsOriginal,
  Reason as ReasonOriginal,
  ReasonWithLiterals as ReasonWithLiteralsOriginal,
  Factor as FactorOriginal,
  FactorType as FactorTypeOriginal,
  FactorTypeWithLiterals as FactorTypeWithLiteralsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  CustomValue as CustomValueOriginal,
  CustomValueValueOneOf as CustomValueValueOneOfOriginal,
  ListValue as ListValueOriginal,
  MapValue as MapValueOriginal,
  RequireMfaData as RequireMfaDataOriginal,
  V1Factor as V1FactorOriginal,
  FactorStatus as FactorStatusOriginal,
  FactorStatusWithLiterals as FactorStatusWithLiteralsOriginal,
  MfaReason as MfaReasonOriginal,
  MfaReasonWithLiterals as MfaReasonWithLiteralsOriginal,
  MfaChallengeData as MfaChallengeDataOriginal,
  VerificationChallenge as VerificationChallengeOriginal,
  VerificationChallengeFactorChallengeDataOneOf as VerificationChallengeFactorChallengeDataOneOfOriginal,
  PushChallengeData as PushChallengeDataOriginal,
  WebAuthnChallengeData as WebAuthnChallengeDataOriginal,
  CreateRecoveryTokenRequest as CreateRecoveryTokenRequestOriginal,
  CreateRecoveryTokenResponse as CreateRecoveryTokenResponseOriginal,
} from './iam-recovery-v1-recovery-recovery.types.js';
